import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'

import { localize } from 'helpers/translator'
import FullOverlay from 'views/overlay/full_overlay/FullOverlay'
import Bodymovin from 'components/bodymovin/bodymovin'
import adminOnboardingPremiumActivitiesSelector from 'redux/selectors/admin_onboarding/admin_onboarding_premium_activities_selector'

import styles from '../PremiumActivitiesNotification.scss'
import icon from 'assets/views/admin_onboarding/clock.svg'

const cx = classNames.bind(styles)

class PremiumActivitiesIntro extends PureComponent {

	constructor() {
		super()
		this.state = {
			componentStatus: 'init',
		}
		this.shareListeners = {
			onComplete: this.animationCompleted.bind(this),
		}
	}

	createTitle = () => (
		<span>
			{localize('admin_onboarding_premium_activities_intro_title_part1')} <br />
			{localize('admin_onboarding_premium_activities_intro_title_part2')}
			<strong className={cx({ strong: true })}>{localize('admin_onboarding_premium_activities_intro_title_part3')}</strong>
			{localize('admin_onboarding_premium_activities_intro_title_part4')}
		</span>
	)

	createAsset = () => (
		<Bodymovin
			path='/assets/media/animations/mps-vft-anim/mps-vft-anim.json'
			loop={false}
			listeners={this.shareListeners}
		>
			<div style={{
				width: '100%',
				height: '100%',
			}}></div>
		</Bodymovin>
	)

	animationCompleted() {
		this.props.introCompleted()
	}

	render() {

		return (
			<FullOverlay
				notificationIcon={icon}
				notificationText={this.props.offerTitle}
				title={this.createTitle()}
				assetSource={this.createAsset()}
				assetWidth='500px'
				assetHeight='500px'
				minHeight='660px'
			/>
		)
	}
}

PremiumActivitiesIntro.propTypes = {
	introCompleted: PropTypes.func,
}

PremiumActivitiesIntro.defaultProps = {
	introCompleted: () => {},
}

function mapStateToProps(state) {
	return adminOnboardingPremiumActivitiesSelector(state)
}

export default connect(mapStateToProps, null)(PremiumActivitiesIntro)
